// extracted by mini-css-extract-plugin
export default {"card":"GalleryImage_card__8YufR","CardImg":"GalleryImage_CardImg__-gTGm","CarBody":"GalleryImage_CarBody__p+39c","CardBtn":"GalleryImage_CardBtn__DAbJz"};